import React from 'react';
import { ProjectCard } from './ProjectCard';
import { Project } from '../../types/project';

interface ProjectsListProps {
    projects: Project[];
    isLoading: boolean;
    error: string | null;
    onDeleteProject: (projectId: string) => void;
    onContinueProject: (projectId: string) => void;
}

export const ProjectsList: React.FC<ProjectsListProps> = ({
    projects,
    isLoading,
    error,
    onDeleteProject,
    onContinueProject,
}) => {
    if (isLoading) {
        return (
            <div className="text-sm text-muted-foreground">Loading projects...</div>
        );
    }

    if (error) {
        return (
            <div className="text-sm text-destructive">{ error }</div>
        );
    }

    if (projects.length === 0) {
        return (
            <div className="text-center text-muted-foreground py-16">
                <p className="text-sm">You have no projects yet. Start by uploading a track.</p>
            </div>
        );
    }

    return (
        <div>
            <h2 className="text-lg font-semibold mb-4 text-card-foreground">Previous Projects</h2>
            <div className="grid overflow-auto h-[400px] grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                { projects.map((project, idx) => (
                    <ProjectCard
                        key={ project.project_id || idx }
                        project={ project }
                        onDelete={ onDeleteProject }
                        onContinue={ onContinueProject }
                    />
                )) }
            </div>
        </div>
    );
}; 